<template>
  <Catalogs
    title="Статусы лидов"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'LeadStatusAdd'"
    :route-edit="'LeadStatusEdit'"
    :route-view="'LeadStatusView'"
    :route-path="'/lead_statuses'"
    :can-edit="canEditLeadStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LeadStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getLeadStatuses(data);
    },
    canEditLeadStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_LEAD_STATUS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LeadStatuses/LeadStatuses.vue